<script setup lang="ts">
import { computed } from "vue";

import type { DictsysArticle } from "@/types";

import LeArticleContextExamples from "./LeArticleContextExamples.vue";
import LeArticleMeaning from "./LeArticleMeaning.vue";
import LeArticlePhrases from "./LeArticlePhrases.vue";

const props = defineProps<{ article: DictsysArticle }>();

const showMeaningNumbers = computed<boolean>(() => {
  if (props.article.article.meanings.some((meaning) => meaning.definition)) {
    return true;
  }

  return props.article.article.meanings.length > 1;
});
</script>

<template>
  <div class="le-article-body-expanded">
    <div v-for="(meaning, index) in props.article.article.meanings" :key="meaning.id">
      <LeArticleMeaning
        :usage-language="props.article.usageLanguage"
        :source-language="props.article.sourceLanguage"
        :target-language="props.article.targetLanguage"
        :lemma-wordclass="props.article.article.wordclass"
        :number="showMeaningNumbers ? index + 1 : undefined"
        :meaning="meaning"
        :index-translation-ids="props.article.indexTranslationIds"
        :index-combination-ids="props.article.indexCombinationIds"
        class="le-article-body-expanded__meaning"
      />
    </div>
    <LeArticlePhrases
      v-if="props.article.article.phrases.length > 0"
      :phrases="props.article.article.phrases"
      :source-language="props.article.sourceLanguage"
      :target-language="props.article.targetLanguage"
      class="le-article-body-expanded__phrases"
    />

    <LeArticleContextExamples
      v-if="props.article.article.contextExamples.length > 0"
      :context-examples="props.article.article.contextExamples"
      :target-language="props.article.targetLanguage"
      class="le-article-body-expanded__context-examples"
    />
  </div>
</template>

<style lang="less" scoped>
.le-article-body-expanded {
  &__phrases {
    margin-top: 20px;
  }

  &__context-examples {
    margin-top: 28px;
  }
}
</style>
